import { Typography } from "@material-ui/core";
import React from "react";
import CashoutPage from "../CashoutPage/CashoutPage";

const Cashout = () => {
  return (
    <>
      <Typography variant="h4">Cashout..</Typography> <CashoutPage />
    </>
  );
};

export default Cashout;
